import * as React from "react";
import type { SVGProps } from "react";
const SvgIconJusticeScale = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.86 2.4c-.27.04-.55.26-.65.52-.06.14-.06.14-.07 1.4v1.25H7.07l-4.04.01-.16.08c-.35.17-.53.52-.48.9.05.32.28.58.61.7.04.01.43.03.88.04l.8.01-1.94 4.38C.83 16.01.81 16.07.8 16.24l.01.5c.22 2.49 2.07 4.47 4.5 4.83.33.04 1.02.05 1.34 0 2.3-.28 4.12-2.04 4.53-4.35.06-.35.1-.93.07-1.09 0-.06-.89-2.06-1.95-4.46L7.37 7.31 12 7.3l4.63.01-1.9 4.32-1.96 4.4q-.03.08-.03.36.01 1.07.46 2.09c.76 1.7 2.32 2.87 4.15 3.1.32.04 1.01.03 1.33-.01 2.44-.36 4.29-2.34 4.5-4.83.02-.18.03-.4.02-.5 0-.17-.03-.23-1.95-4.55L19.3 7.31l.8-.01c.46-.01.85-.03.89-.04q.38-.13.54-.48c.06-.13.07-.18.08-.34q0-.54-.48-.78l-.16-.08h-4.05l-4.05-.01-.01-1.25c0-1.22 0-1.26-.06-1.38-.16-.38-.52-.6-.94-.54M6.01 8.6l-3.03 6.8c0 .03.61.03 3.04.03 2.9 0 3.06 0 3.05-.04L6.05 8.6q-.02-.04-.04.02m10.43 3.38-1.51 3.44c0 .01 6.1.02 6.1 0S18 8.6 17.97 8.6c-.01-.01-.7 1.52-1.54 3.4m-13.8 5.24c.02.13.16.5.26.71.27.55.75 1.09 1.27 1.42.14.1.5.27.7.34 1.22.46 2.64.14 3.58-.8.31-.3.48-.54.67-.9.13-.24.31-.72.31-.81 0-.04-.28-.04-3.4-.04H2.62zm11.93-.04c0 .1.18.57.31.82.19.36.35.58.67.9q.81.8 1.96.96c1.62.23 3.2-.75 3.77-2.35l.09-.3.01-.07h-3.4c-3.13 0-3.41 0-3.41.04"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconJusticeScale;
